import type { ProjectFileResponseDto } from '@inference.engine/workspace-api-client/web';

export interface FolderChainSummary {
  name: string;
  total: number;
  completed: number;
}

export interface FolderDefaultApprovalSummary {
  total: number;
  approved: number;
}

export interface FolderChainBreakdown {
  chains: FolderChainSummary[];
  defaults: FolderDefaultApprovalSummary;
}

export function summarizeFolderChains(files: ProjectFileResponseDto[]): FolderChainBreakdown {
  const chains = new Map<string, FolderChainSummary>();
  const defaults: FolderDefaultApprovalSummary = { total: 0, approved: 0 };

  for (const file of files) {
    const progress = file.workflowProgress;

    if (!progress) {
      defaults.total += 1;
      if (file.status === 'approved') defaults.approved += 1;
      continue;
    }

    let chain = chains.get(progress.workflowName);
    if (!chain) {
      chain = { name: progress.workflowName, total: 0, completed: 0 };
      chains.set(progress.workflowName, chain);
    }

    chain.total += 1;
    if (progress.status === 'completed') chain.completed += 1;
  }

  return {
    chains: [...chains.values()].sort((a, b) => a.name.localeCompare(b.name)),
    defaults,
  };
}
